import React, { Component, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { VerticalSp, HorizontalSp, HSLine } from '../Common';
import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';
import Rating from '@material-ui/lab/Rating';
import { useTranslation } from 'react-i18next';
import store from '../../store';
import Unity, { UnityContext } from 'react-unity-webgl';

import images from '../../assets';
import Ratio from 'react-ratio';
import Store from 'store';
import Tooltip from '@material-ui/core/esm/Tooltip/Tooltip';
import { Fade, Popper } from '@material-ui/core';
import t from 'i18next';
import { marketingApi } from '../../marketing-api';
import { CustomButton } from '../../components/ai_generate/generateDetailView';
import { getCurrentLang } from '../../libs/lang';

export const DesignTitle = styled.div`
  font-family: 'NSCJKrB';
  font-size: 42px;
  color: 'black';
  line-height: 42px;
`;

export const CreateBy = styled.div`
  font-family: 'NSCJKrR';
  font-size: 16px;
  color: #999999;
  line-height: 16px;
  padding-bottom: 4px;
`;

export const CreateName = styled.div`
  font-family: 'NSCJKrR';
  font-size: 18px;
  color: black;
  line-height: 18px;
  padding-bottom: 4px;
`;

export const Viewers = styled.div`
  font-family: 'NSCJKrR';
  font-size: 14px;
  color: #666666;
  line-height: 14px;
  padding-bottom: 2px;
`;

export const Favoris = styled.div`
  font-family: 'NSCJKrR';
  font-size: 14px;
  color: #999999;
  line-height: 14px;
  padding-bottom: 2px;
`;

export const PreMaskTag = styled.div`
  margin: 17px auto;
  display: flex;
  justify-content: center;
  cursor: pointer;
  position: relative;
`;

export const PreviewTag = styled.div`
  overflow: hidden;
  position: relative;
  cursor: pointer;
`;

const DesignImg = styled.div`
  position: absolute;
  background-size: 60%;
  background-position: 0% 0%;
  z-index: -1;
`;

const unityContext = new UnityContext({
  loaderUrl: process.env.REACT_APP_UNITY_LOAD,
  dataUrl: process.env.REACT_APP_UNITY_DATA,
  frameworkUrl: process.env.REACT_APP_UNITY_FRAMEWORK,
  codeUrl: process.env.REACT_APP_UNITY_CODE,
});

export const PreviewArea = ({ pngimg = null, designimg, width = '6.6vw' }) => {
  return pngimg != null ? (
    <PreviewTag
      style={{
        width,
        height: width,
      }}
    >
      <img
        alt=""
        src={pngimg}
        style={{
          position: 'absolute',
          zIndex: 10,
          height: '100%',
        }}
      />
      <DesignImg
        style={{
          backgroundImage: `url(${designimg})`,
          width,
          height: width,
        }}
      />
    </PreviewTag>
  ) : (
    <PreviewTag style={{ width, height: width }}>
      <DesignImg
        style={{
          backgroundImage: `url(${designimg})`,
          width,
          height: width,
        }}
      />
    </PreviewTag>
  );
};

export const MaterialLbl = ({ children }) => {
  return (
    <div
      style={{
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgb(0,0,0,0.5)',
        zIndex: 999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          color: 'white',
        }}
      >
        {' '}
        {children}{' '}
      </div>{' '}
    </div>
  );
};

export const ZoomTooltip = ({ title, content, children, ...otherprops }) => {
  return (
    <Tooltip
      placement="left"
      PopperComponent={({ style, ...props }) => (
        <Popper
          {...props}
          style={{ ...style, zIndex: 500 }} // width is passed in 'style' prop
        />
      )}
      // TransitionComponent={Fade}
      TransitionProps={{
        style: {
          backgroundColor: '#f1f1f1',
          margin: 0,
          marginBottom: 5,
          boxShadow: '-2px 2px 2px 2px rgb(232, 232, 232)',
        },
        timeout: 0,
      }}
      title={
        <div>
          <div
            style={{
              fontFamily: 'NSCJKrR',
              color: '#ff8a06',
              fontSize: 12,
              lineHeight: '24px',
              position: 'relative',
              fontWeight: 'bold',
              textAlign: 'center',
            }}
          >
            {'TIP'}
          </div>
          <div
            style={{
              fontFamily: 'NSCJKrR',
              color: 'black',
              fontSize: 11,
              lineHeight: '16px',
              position: 'relative',
              whiteSpace: 'pre-wrap',
              textAlign: 'center',
            }}
          >
            {title}
          </div>
        </div>
      }
      {...otherprops}
    >
      {children}
    </Tooltip>
  );
};

const ZoomSlider = withStyles({
  root: {
    color: '#dddddd',
  },
  thumb: {
    height: 30,
    width: 20,
    borderRadius: 0,
    backgroundColor: '#fff',
    marginBottom: '-15px !important',
    marginLeft: '-9px !important',
    backgroundImage: `url(${images.icon_sliderthumb})`,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
})(Slider);

export class MainPreview extends Component {
  static defaultProps = {
    width: 700,
    maskimg: null,
    pngimg: null,
    designimg: null,
    mainPreviewSize: 'large',
    verticalHorizonRadio: [1, 1],
  };

  state = {
    hover: false,
    pressed: false,
    zoomval: 60,
    cropZoomval: 150,
    left: 0,
    top: 0,
    cropLeft: 0,
    cropTop: 0,
    product_id: null,
    product_name: null,
    res_preview_large_path: null,
    zoomTooltipOpen: true,
    startX: 0,
    startY: 0,
    touchX: 0,
    touchY: 0,
    splashShow: true,
    splashTimerStarted: false,
  };
  timer = null;

  componentDidMount = () => {
    // Unity 로드 완료 이벤트 등록
    unityContext.on('loaded', () => {
      // 기존 타이머 초기화 (중복 방지)
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      // 3초 뒤 splash 제거
      this.timer = setTimeout(() => {
        this.setState({ splashShow: false, splashTimerStarted: false }, () => {
          this.timer = null;
        });
      }, 2500);
    });
  };

  handleUnityReady = () => {
    this.applyTexture(this.props.product_id);
    const currLang = getCurrentLang();
    unityContext.send('LangMgr', 'ChangeLang', currLang);
  };

  applyTexture = (id) => {
    unityContext.send(
      'MainManager',
      'ChangeTextureUseId_FromJs',
      JSON.stringify({ textureId: Number(id), isAI: true }),
    );
  };

  componentDidUpdate = (prevProps) => {
    const { product_id, product_name, designimg } = this.props;
    if (product_id !== prevProps.product_id) {
      this.setState({
        product_name: product_name,
        product_id: product_id,
        zoomval: 60,
        zoomTooltipOpen: true,
        designimg,
      });
      this.applyTexture(product_id);
    }
    unityContext.on('OnGameStart', this.handleUnityReady);
  };

  componentWillUnmount() {
    this.unbindEventListeners();
  }

  unbindEventListeners() {
    window.removeEventListener('mouseup', this.handleMouseUp);
    window.removeEventListener('mousemove', this.handleChange);
    window.removeEventListener('mousedown', this.handletouchend);
  }

  handleMouseDown = (e) => {
    this.setState({
      pressed: true,
    });
    //his.handleChange(e, true)
    window.addEventListener('mousedown', this.handletouchend);
    window.addEventListener('mouseup', this.handleMouseUp);
    window.addEventListener('mousemove', this.handleChange);
  };

  handletouchend = (ev) => {
    if (ev.type === 'touchstart') {
      const touchX = ev.targetTouches[0].clientX;
      const touchY = ev.targetTouches[0].clientY;
      this.setState({
        touchX: touchX,
        touchY: touchY,
      });
    }
  };

  handleMouseUp = (ev) => {
    this.setState({
      pressed: false,
    });

    this.unbindEventListeners();
  };

  handleMouseOver = () => {
    this.setState({
      hover: true,
    });
  };

  handleMouseOut = () => {
    this.setState({
      hover: false,
    });
  };

  handleChange = (ev, skip) => {
    // ev.preventDefault();
    const { mainPreviewSize, verticalHorizonRadio } = this.props;
    const { cropZoomval, left, top, cropLeft, cropTop, touchX, touchY } = this.state;
    const calWidth = this.container.getBoundingClientRect().width;
    const cx = parseInt(this.container.style.backgroundPositionX.replace('px', ''));
    const cy = parseInt(this.container.style.backgroundPositionY.replace('px', ''));
    let valueLeft, valueTop, test, touch;
    if (ev.type === 'touchmove') {
      // 터치 이벤트 처리

      touch = ev.touches[0]; // 첫 번째 터치 이벤트 정보만 사용
      valueLeft = (cx + (touch.clientX - touchX)) % calWidth;
      valueTop = (cy + (touch.clientY - touchY)) % calWidth;
      this.setState({
        touchX: touch.clientX,
        touchY: touch.clientY,
      });
    } else {
      // 마우스 이벤트 처리
      valueLeft = (cx + ev.movementX) % calWidth;
      valueTop = (cy + ev.movementY) % calWidth;
    }

    if (mainPreviewSize === 'cropped') {
      let verV, horizonV;
      if (verticalHorizonRadio[0] > verticalHorizonRadio[1]) {
        const radioV = Math.max(verticalHorizonRadio[0], verticalHorizonRadio[1]);
        verV = parseInt(-((cropZoomval / 100) * calWidth * verticalHorizonRadio[0] - calWidth) / radioV);
        horizonV = parseInt(-((cropZoomval / 100) * calWidth * verticalHorizonRadio[1] - calWidth) / radioV);
      } else {
        const radioV = Math.max(verticalHorizonRadio[0], verticalHorizonRadio[1]);
        verV = parseInt(-((cropZoomval / 100) * calWidth * verticalHorizonRadio[0] - calWidth) / radioV);
        horizonV = parseInt(-((cropZoomval / 100) * calWidth * verticalHorizonRadio[1] - calWidth));
      }

      valueLeft = Math.min(valueLeft, 0);
      valueTop = Math.min(valueTop, 0);

      valueLeft = Math.max(valueLeft, verV);
      valueTop = Math.max(valueTop, horizonV);

      // console.log('horizonV: ', horizonV);
      // console.log('valueTop: ', valueTop);

      this.setState({
        cropLeft: valueLeft,
        cropTop: valueTop,
      });
    } else {
      this.setState({
        left: valueLeft,
        top: valueTop,
      });
    }
  };

  onCropZoomIn = () => {
    const { cropZoomval } = this.state;

    var t_val = cropZoomval + 10;
    if (t_val >= 200) {
      t_val = 200;
    }
    this.setState({
      cropZoomval: t_val,
      zoomTooltipOpen: false,
      left: 0,
      top: 0,
      cropLeft: 0,
      cropTop: 0,
    });

    marketingApi.useClickDetailZoomEffect(this.state.product_name, '확대', t_val);
  };

  onCropZoomOut = () => {
    const { cropZoomval } = this.state;
    var t_val = cropZoomval - 10;
    if (t_val <= 100) {
      t_val = 100;
    }
    this.setState({
      cropZoomval: t_val,
      zoomTooltipOpen: false,
      left: 0,
      top: 0,
      cropLeft: 0,
      cropTop: 0,
    });
    marketingApi.useClickDetailZoomEffect(this.state.product_name, '축소', t_val);
  };
  onZoomIn = () => {
    const { zoomval } = this.state;

    var t_val = zoomval + 10;
    if (t_val >= 100) {
      t_val = 100;
    }
    this.setState({
      zoomval: t_val,
      zoomTooltipOpen: false,
      left: 0,
      top: 0,
      cropLeft: 0,
      cropTop: 0,
    });

    marketingApi.useClickDetailZoomEffect(this.state.product_name, '확대', t_val);
  };

  onZoomOut = () => {
    const { zoomval } = this.state;
    var t_val = zoomval - 10;
    if (t_val <= 20) {
      t_val = 20;
    }
    this.setState({
      zoomval: t_val,
      zoomTooltipOpen: false,
      left: 0,
      top: 0,
      cropLeft: 0,
      cropTop: 10,
    });
    marketingApi.useClickDetailZoomEffect(this.state.product_name, '축소', t_val);
  };

  handleTouchStart = (e, skip) => {
    this.setState({
      pressed: true,
    });
    //this.handleChange(e, skip)
    window.addEventListener('touchend', this.handleMouseUp);
  };

  renderPreveiwDesignImg = (pngimg) => {
    const { designimg, mainPreviewSize, verticalHorizonRadio, width } = this.props;
    const { zoomval, cropZoomval, left, top, cropLeft, cropTop } = this.state;
    let imgBoxV = 100;
    if (verticalHorizonRadio[0] > verticalHorizonRadio[1]) {
      const betterV = Math.max(verticalHorizonRadio[0], verticalHorizonRadio[1]);
      imgBoxV = imgBoxV * betterV;
    }
    if (mainPreviewSize === 'large') {
      return (
        <>
          <PreviewTag
            style={{
              width: '100%',
              height: '100%',
              cursor: 'move',
              touchAction: 'none',
            }}
            onMouseOver={this.handleMouseOver}
            onMouseOut={this.handleMouseOut}
            onMouseDown={this.handleMouseDown}
            onTouchMove={this.handleChange}
            onTouchStart={this.handleTouchStart}
          >
            <div
              style={{
                position: 'absolute',
                zIndex: 10,
                width: '100%',
                height: '100%',
                left: 0,
                top: 0,
                backgroundImage: `url(${pngimg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            />{' '}
            <div
              ref={(container) => (this.container = container)}
              style={{
                position: 'absolute',
                zIndex: -1,
                width: '98%',
                height: '98%',
                backgroundSize: `${zoomval}%`,
                backgroundPosition: `${left}px ${top}px`,
                backgroundImage: `url(${designimg})`,
              }}
            />
          </PreviewTag>
        </>
      );
    } else if (mainPreviewSize === 'cropped') {
      return (
        <>
          <PreviewTag
            style={{
              width: '100%',
              height: '100%',
              cursor: 'move',
              touchAction: 'none',
            }}
            onMouseOver={this.handleMouseOver}
            onMouseOut={this.handleMouseOut}
            onMouseDown={this.handleMouseDown}
            onTouchMove={this.handleChange}
            onTouchStart={this.handletouchend}
          >
            <div
              style={{
                position: 'absolute',
                zIndex: 10,
                width: '100%',
                height: '100%',
                left: 0,
                top: 0,
                backgroundImage: `url(${pngimg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            />
            <div
              ref={(container) => (this.container = container)}
              style={{
                position: 'absolute',
                zIndex: -1,
                width: `${imgBoxV}%`,
                height: `${imgBoxV}%`,
                backgroundSize: `${cropZoomval}%`,
                backgroundPosition: `${cropLeft}px ${cropTop}px`,
                // backgroundPosition: '0px -710px',
                backgroundImage: `url(${designimg})`,
                backgroundRepeat: 'no-repeat',
              }}
            />
          </PreviewTag>
        </>
      );
    }
  };

  renderUnityView = () => {
    const { splashShow } = this.state;

    return (
      <div style={{ backgroundImage: `url(${images.tdb_big_logo})` }}>
        {splashShow && (
          <div
            className="splash"
            style={{ backgroundImage: `url(${images.tdb_big_logo})`, width: '1000px', height: '1000px' }}
          ></div>
        )}
        <Unity
          unityContext={unityContext}
          style={{
            position: 'absolute',
            backgroundRepeat: 'no-repeat',
            width: '700px',
            height: '700px',
            // background: '#ff8700',
            backgroundImage: `url(${images.tdb_big_logo})`,
            backgroundSize: 'cover',
          }}
        />
      </div>
    );
  };

  onKeyPressed = (e) => {
    if (e.keyCode === 112) {
      unityContext.send('MainManager', 'EnableUI');
    }
  };

  render() {
    const { width, pngimg, isUnityView, mainPreviewSize } = this.props;
    const { zoomval, zoomTooltipOpen, cropZoomval, splashShow } = this.state;

    const isNeedSplash = !isUnityView && !splashShow;

    if (isNeedSplash) {
      this.setState({ splashShow: true, splashTimerStarted: false });
    }

    if (isUnityView === true) {
      unityContext.send('MainManager', 'OnChagneTextureZoom', (100 - zoomval) * 0.01);
    }

    return (
      <div
        onKeyDown={this.onKeyPressed}
        tabIndex="0"
        style={{
          display: 'flex',
          justifyContent: 'center',
          zIndex: 999,
        }}
      >
        <Ratio
          ratio={1}
          style={{
            width: width,
            display: 'flex',
            alignItems: 'center',
            overflow: 'hidden',
          }}
        >
          {isUnityView ? this.renderUnityView() : this.renderPreveiwDesignImg(pngimg)}
        </Ratio>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            backgroundColor: 'white',
            height: width,
            zIndex: 99,
          }}
        >
          {mainPreviewSize === 'large' ? (
            <div
              onClick={this.onZoomIn}
              style={{
                width: 48,
                height: 52,
                backgroundImage: `url(${images.zoom_plus_icon})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                cursor: 'pointer',
                zIndex: 99,
              }}
            >
              {' '}
            </div>
          ) : (
            <div
              onClick={this.onCropZoomIn}
              style={{
                width: 48,
                height: 52,
                backgroundImage: `url(${images.zoom_plus_icon})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                cursor: 'pointer',
                zIndex: 99,
              }}
            >
              {' '}
            </div>
          )}{' '}
          <VerticalSp sp={'1.6vw'} />{' '}
          <ZoomTooltip title={t.t('zoom_tooltip')} open={zoomTooltipOpen}>
            {mainPreviewSize === 'large' ? (
              <ZoomSlider
                track={false}
                max={97}
                min={20}
                orientation="vertical"
                onChange={(event, value) => {
                  this.setState({
                    zoomval: value,
                    zoomTooltipOpen: false,
                    left: 0,
                    top: 0,
                    cropLeft: 0,
                    cropTop: 0,
                  });
                }}
                value={zoomval}
                defaultValue={zoomval}
              />
            ) : (
              <ZoomSlider
                track={false}
                max={200}
                min={110}
                orientation="vertical"
                onChange={(event, value) => {
                  this.setState({
                    cropZoomval: value,
                    zoomTooltipOpen: false,
                    left: 0,
                    top: 0,
                    cropLeft: 0,
                    cropTop: 0,
                  });
                }}
                value={cropZoomval}
                defaultValue={cropZoomval}
              />
            )}
          </ZoomTooltip>
          <VerticalSp sp={'1.6vw'} />{' '}
          {mainPreviewSize === 'large' ? (
            <div
              onClick={this.onZoomOut}
              style={{
                width: 48,
                height: 52,
                backgroundImage: `url(${images.zoom_minus_icon})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                cursor: 'pointer',
                zIndex: 99,
              }}
            >
              {' '}
            </div>
          ) : (
            <div
              onClick={this.onCropZoomOut}
              style={{
                width: 48,
                height: 52,
                backgroundImage: `url(${images.zoom_minus_icon})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                cursor: 'pointer',
                zIndex: 99,
              }}
            >
              {' '}
            </div>
          )}{' '}
        </div>{' '}
      </div>
    );
  }
}

export const Destagtxt = styled.div`
  font-family: 'NSCJKrR';
  font-size: 16px;
  color: black;
  line-height: 16px;
`;

export const ColorTag = ({ bgcolor = null, style, ...props }) => {
  const [mouseon, setMouseOn] = useState(false);
  return (
    <div
      {...props}
      style={{
        flex: 1,
        height: mouseon ? 30 : 10,
        cursor: 'pointer',
        backgroundColor: `#${bgcolor}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...style,
      }}
      onMouseEnter={() => {
        setMouseOn(true);
      }}
      onMouseLeave={() => {
        setMouseOn(false);
      }}
    >
      {' '}
      {mouseon && (
        <div
          style={{
            color: 'white',
            fontFamily: 'NSCJKrM',
            fontSize: 16,
            lineHeight: '16px',
            height: 16,
          }}
        >
          {' '}
          {bgcolor}{' '}
        </div>
      )}{' '}
    </div>
  );
};

export const LicensBlock = styled.div`
  width: 100%;
  border: 1px solid #dddddd;
  min-height: 280px;
`;

export const LicensHead = styled.div`
  color: #fe8b07;
  background-color: #222222;
  line-height: 35px;
  font-size: 14;
  font-family: 'NSCJKrB';
  padding-left: 15px;
`;

const TLicenseTitle = styled.div`
  font-family: 'NSCJKrB';
  font-size: 22px;
  line-height: 22px;
  height: 22px;
  color: black;
  display: flex;
  align-items: center;
`;

const TLicensCompare = styled.div`
  font-family: 'NSCJKrM';
  font-size: 12px;
  color: #fe8b07;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const LicenseTitle = ({ onClick }) => {
  const { t } = useTranslation();
  return (
    <TLicenseTitle>
      {t('license_type')} <HorizontalSp sp={10} />{' '}
      <TLicensCompare onClick={onClick}>{t('compare_licenses')} </TLicensCompare>
    </TLicenseTitle>
  );
};

export const LicenseType = ({ onClick, value, typetitle, filetype, typedes }) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
      }}
      onClick={onClick}
    >
      <img
        alt=""
        src={value ? images.icon_license_act : images.icon_license_nor}
        style={{
          marginTop: 3,
        }}
      />{' '}
      <HorizontalSp sp={10} />{' '}
      <div
        style={{
          flex: 1,
        }}
      >
        <div
          style={{
            fontFamily: 'NSCJKrM',
            fontSize: 16,
            color: 'black',
            lineHeight: '16px',
            display: 'flex',
          }}
        >
          <div> {typetitle} </div>{' '}
          <div
            style={{
              flex: 1,
            }}
          />{' '}
          <div> {filetype} </div>{' '}
        </div>{' '}
        <VerticalSp sp={8} />{' '}
        <div
          style={{
            fontFamily: 'NSCJKrR',
            fontSize: 14,
            color: '#666666',
            lineHeight: '14px',
            height: 14,
          }}
        >
          {' '}
          {typedes}{' '}
        </div>{' '}
      </div>{' '}
    </div>
  );
};

export const CreditPrice = ({ onClick }) => {
  const { t } = useTranslation();
  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div style={{ alignItems: 'center', margin: '5px 2px 0px 0px' }}>
          <img style={{ content: `url(${images.credit_active})`, width: 20, height: 20 }} />
        </div>
        <span
          style={{
            fontFamily: 'NSCJKrR',
            fontSize: 16,
            color: '#ff8a06',
          }}
        >
          {t('purchase_with_credit2')}
        </span>

        <div
          style={{
            flex: 1,
          }}
        />

        <div
          style={{
            fontFamily: 'NSCJKrB',
            fontSize: 36,
            color: 'rgb(0,0,0,0)',
            position: 'relative',
            lineHeight: '36px',
            height: 36,
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'baseline',
            }}
          >
            <span
              style={{
                fontFamily: 'NSCJKrB',
                fontSize: 24,
                color: 'black',
              }}
            >
              1
            </span>
            <span
              style={{
                fontSize: 16,
                color: 'black',
              }}
            >
              &nbsp;
              {t('credit2')}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};
export const PurchaseWithMyCredit = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <>
      <VerticalSp sp={30} />
      <HSLine bgcolor="#dddddd" />
      <div
        style={{
          display: 'flex',
          alignItems: 'baseline',
          flexDirection: 'row',
        }}
      >
        <span
          style={{
            fontFamily: 'NSCJKrR',
            fontSize: 18,
            color: '#999999',
          }}
        >
          {t('purchase_with_credit')}
        </span>
        <div
          style={{
            flex: 1,
          }}
        />
        <div
          style={{
            fontFamily: 'NSCJKrB',
            fontSize: 36,
            color: 'rgb(0,0,0,0)',
            position: 'relative',
            lineHeight: '36px',
            height: 36,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'end',
          }}
        ></div>

        <div
          style={{
            position: 'relative',
          }}
        >
          <div
            style={{
              position: 'absolute',
              width: '100%',
              height: 10,
              backgroundColor: '#ffff2f',
              bottom: 4,
              zIndex: -1,
            }}
          />
          <span
            style={{
              fontSize: 24,
            }}
          >
            1크레딧
          </span>
        </div>
      </div>

      <VerticalSp sp={10} />
      <div
        style={{
          display: 'flex',
          alignItems: 'baseline',
          flexDirection: 'row',
        }}
      >
        <span
          style={{
            fontFamily: 'NSCJKrR',
            fontSize: 14,
            color: '#999999',
            marginLeft: '20px',
          }}
        >
          {t('current_my_credit')}
        </span>
        <div
          style={{
            flex: 1,
          }}
        />
        <div
          style={{
            fontFamily: 'NSCJKrB',
            fontSize: 36,
            color: 'rgb(0,0,0,0)',
            position: 'relative',
            lineHeight: '36px',
            height: 36,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'end',
          }}
        ></div>

        <div
          style={{
            position: 'relative',
          }}
        >
          <div
            style={{
              position: 'absolute',
              width: '100%',
              height: 10,
              backgroundColor: '#ffff2f',
              bottom: 4,
              zIndex: -1,
            }}
          />
          <span
            style={{
              fontSize: 14,
            }}
          >
            20크레딧
          </span>
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          alignItems: 'baseline',
          flexDirection: 'row',
        }}
      >
        <span
          style={{
            fontFamily: 'NSCJKrR',
            fontSize: 14,
            color: '#999999',
            marginLeft: '20px',
          }}
        >
          차감 크레딧
        </span>
        <div
          style={{
            flex: 1,
          }}
        />
        <div
          style={{
            fontFamily: 'NSCJKrB',
            fontSize: 36,
            color: 'rgb(0,0,0,0)',
            position: 'relative',
            lineHeight: '36px',
            height: 36,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'end',
          }}
        ></div>

        <div
          style={{
            position: 'relative',
          }}
        >
          <div
            style={{
              position: 'absolute',
              width: '100%',
              height: 10,
              backgroundColor: '#ffff2f',
              bottom: 4,
              zIndex: -1,
            }}
          />
          <span
            style={{
              fontSize: 14,
            }}
          >
            -1 크레딧
          </span>
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'baseline',
          flexDirection: 'row',
        }}
      >
        <VerticalSp sp={20} />
        <div
          style={{
            flex: 2,
          }}
        />
        <CustomButton onClick={onClick} style={{ color: 'white', backgroundColor: '#fe8b07' }}>
          크레딧으로 구매{' '}
        </CustomButton>
      </div>
    </>
  );
};

export const LicensePrice = ({ unit, cost, sale = 0 }) => {
  const { t } = useTranslation();
  const sale_percent = () => {
    return Math.round(((cost - sale) * 100) / cost); // 20%
  };
  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'baseline',
        }}
      >
        <span
          style={{
            fontFamily: 'NSCJKrR',
            fontSize: 18,
            color: '#999999',
          }}
        >
          {t('total_amount')}
        </span>
        <div
          style={{
            flex: 1,
          }}
        />
        <div
          style={{
            fontFamily: 'NSCJKrB',
            fontSize: 30,
            color: 'rgb(0,0,0,0)',
            position: 'relative',
            lineHeight: '36px',
            height: 36,
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'baseline',
            }}
          >
            <span
              style={{
                fontSize: 24,
              }}
            >
              {unit}
            </span>
            {sale > 0 ? sale?.toLocaleString() : cost?.toLocaleString()}
            {sale > 0 && (
              <>
                <HorizontalSp sp={4} />
                <span style={{ fontSize: 24 }}>{cost?.toLocaleString()}</span>
              </>
            )}
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'baseline',
              position: 'absolute',
              top: 0,
              fontFamily: 'NSCJKrB',
              fontSize: 30,
              color: 'black',
            }}
          >
            <div
              style={{
                position: 'relative',
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  width: '100%',
                  height: 10,
                  backgroundColor: '#ffff2f',
                  bottom: 4,
                  zIndex: -1,
                }}
              />
              <span
                style={{
                  fontSize: 24,
                }}
              >
                {unit}
              </span>
              {sale > 0 ? sale?.toLocaleString() : cost?.toLocaleString()}
            </div>
            {sale > 0 && (
              <>
                <HorizontalSp sp={4} />
                <div
                  style={{
                    fontSize: 24,
                    color: '#666666',
                    position: 'relative',
                  }}
                >
                  <div
                    style={{
                      position: 'absolute',
                      width: '100%',
                      height: 2,
                      backgroundColor: '#666666',
                      bottom: 13,
                      zIndex: -1,
                    }}
                  />
                  {cost?.toLocaleString()}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {sale > 0 && (
        <div
          style={{
            display: 'flex',
            alignItems: 'baseline',
            justifyContent: 'flex-end',
          }}
        >
          <div
            style={{
              fontFamily: 'NSCJKrB',
              fontSize: 16,
              color: '#e60303',
              lineHeight: '16px',
              height: 16,
            }}
          >
            {sale_percent()} %
          </div>
          <img alt="" src={images.icon_salemark} />
        </div>
      )}
    </>
  );
};

export const LicenseSpec = ({ label, value }) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <div
        style={{
          fontFamily: 'NSCJKrR',
          fontSize: 16,
          color: '#666666',
          lineHeight: '16px',
        }}
      >
        {' '}
        {label}{' '}
      </div>{' '}
      <div
        style={{
          fontFamily: 'NSCJKrM',
          fontSize: 16,
          color: 'black',
          lineHeight: '16px',
        }}
      >
        {' '}
        {value}{' '}
      </div>{' '}
    </div>
  );
};

export const LicenseIcoSpec = ({ label, img }) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <div
        style={{
          fontFamily: 'NSCJKrM',
          fontSize: 16,
          color: 'black',
          lineHeight: '16px',
        }}
      >
        {' '}
        {label}{' '}
      </div>{' '}
      <div
        style={{
          fontFamily: 'NSCJKrM',
          fontSize: 16,
          color: 'black',
          lineHeight: '16px',
        }}
      >
        {' '}
        <img alt="" src={img} />
      </div>
    </div>
  );
};

export const BasketBtn = ({ onClick }) => {
  const { t } = useTranslation();
  return (
    <div
      onClick={onClick}
      style={{
        backgroundColor: '#ff8a06',
        fontFamily: 'NSCJKrB',
        color: 'white',
        fontSize: 24,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 60,
        borderRadius: 5,
        cursor: 'pointer',
      }}
    >
      <img alt="" src={images.icon_basket_white} />
      <HorizontalSp sp={10} />
      {t('add_to_cart')}
    </div>
  );
};

export const FavoriBtn = ({ onClick, isLike = true }) => {
  const { t } = useTranslation();
  return (
    <div
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid #fe8b07',
        borderRadius: 3,
        flex: 1,
        height: 44,
        fontFamily: 'NSCJKrM',
        fontSize: 18,
        color: '#ff8a06',
        cursor: 'pointer',
      }}
    >
      <img alt="" src={isLike ? images.icon_liked : images.icon_likes} />
      <HorizontalSp sp={7} />
      {t('like')}
    </div>
  );
};

export const ShareBtn = ({ onClick }) => {
  const { t } = useTranslation();
  return (
    <div
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid #cccccc',
        borderRadius: 3,
        flex: 1,
        height: 44,
        fontFamily: 'NSCJKrM',
        fontSize: 18,
        color: '#999999',
        cursor: 'pointer',
      }}
    >
      <img alt="" src={images.icon_share} />
      <HorizontalSp sp={7} />
      {t('share')}
    </div>
  );
};

export const RegButton = styled.div`
  font-family: 'NSCJKrM';
  font-size: 16px;
  color: white;
  background-color: #ff8a06;
  width: 150px;
  height: 40px;
  line-height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 5px;
  margin: auto;
`;

export const CommentsInf = ({
  avatar,
  rate,
  writer,
  readonly = true,
  datetime,
  comments,
  onReport,
  onDelete,
  onRatingSet,
  uuid,
}) => {
  const { t } = useTranslation();
  return (
    <div>
      <div
        style={{
          display: 'flex',
          alignItems: 'stretch',
        }}
      >
        {/* <div>
          <img
            alt=''
            src={avatar}
            style={{
              width: 48,
              height: 'auto',
              borderRadius: 100,
            }}
          />
        </div> */}
        <Ratio
          ratio={1}
          style={{
            backgroundImage: `url(${avatar})`,
            width: 48,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            borderRadius: 100,
          }}
        />
        <HorizontalSp sp={20} />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-around',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              fontFamily: 'NSCJKrR',
              fontSize: 16,
              lineHeight: '16px',
              height: 16,
              color: 'black',
            }}
          >
            <Rating
              name="half-rating"
              defaultValue={rate}
              precision={0.5}
              readOnly={readonly}
              onChange={(event, val) => {
                onRatingSet(val);
              }}
            />
            <HorizontalSp sp={8} />
            <span
              style={{
                marginBottom: 2,
              }}
            >
              {rate}
            </span>
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'flex-end',
              fontFamily: 'NSCJKrB',
              fontSize: 16,
              lineHeight: '16px',
              height: 16,
              color: 'black',
            }}
          >
            {writer} <HorizontalSp sp={8} />
            <span
              style={{
                fontFamily: 'NSCJKrR',
                fontSize: 14,
                lineHeight: '14px',
                height: 14,
                color: '#999999',
              }}
            >
              {datetime}
            </span>{' '}
          </div>
        </div>
        {isMobile && readonly && Store.get('accessToken') && (
          <>
            <div
              style={{
                flex: 1,
              }}
            />
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-around',
              }}
            >
              <div
                onClick={onReport}
                style={{
                  fontFamily: 'NSCJKrR',
                  fontSize: 14,
                  lineHeight: '14px',
                  border: '1px solid #cccccc',
                  borderRadius: 3,
                  width: 58,
                  height: 28,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  marginBottom: 5,
                }}
              >
                {t('report_abuse')}
              </div>

              {uuid === store.getState().user_uuid && (
                <div
                  onClick={onDelete}
                  style={{
                    fontFamily: 'NSCJKrR',
                    fontSize: 14,
                    lineHeight: '14px',
                    border: '1px solid #cccccc',
                    borderRadius: 3,
                    width: 58,
                    height: 28,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                  }}
                >
                  {t('delete')}
                </div>
              )}
            </div>
          </>
        )}
      </div>
      {readonly && (
        <>
          <VerticalSp
            sp={'1vw'}
            style={{
              minHeight: 10,
            }}
          />
          <div
            style={{
              display: 'flex',
              alignItems: 'flex-end',
            }}
          >
            <HorizontalSp sp={68} />
            <div
              style={{
                fontFamily: 'NSCJKrR',
                fontSize: 16,
                lineHeight: '20px',
                flex: 1,
              }}
            >
              {comments}
            </div>
            {!isMobile && uuid === store.getState().user_uuid && (
              <div
                onClick={onDelete}
                style={{
                  fontFamily: 'NSCJKrR',
                  fontSize: 14,
                  lineHeight: '14px',
                  border: '1px solid #cccccc',
                  borderRadius: 3,
                  width: 58,
                  height: 28,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  marginRight: 5,
                }}
              >
                {t('delete')}
              </div>
            )}
            {!isMobile && Store.get('accessToken') && (
              <div
                onClick={onReport}
                style={{
                  fontFamily: 'NSCJKrR',
                  fontSize: 14,
                  lineHeight: '14px',
                  border: '1px solid #cccccc',
                  borderRadius: 3,
                  width: 58,
                  height: 28,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                }}
              >
                {t('report_abuse')}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};
